/* eslint-disable global-require,import/no-unresolved,max-len,class-methods-use-this */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Text } from 'react-native'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styles from '../../styles'
import textStyles from '../../styles/text'
import BulletedListView from '../subcomponents/BulletedListView'
import * as ResourceManager from '../methods/ResourceManager'
import LightStageDetails from './LightStageDetails'
import { displayTelephoneLine } from '../methods/RegionalContentLookUp'

class OneSendingWavePage extends Component {
  getTelephoneLineSection() {
    const { locale, t } = this.props
    let returnObj
    if (displayTelephoneLine(locale)) {
      returnObj = (
        <BulletedListView
          testID="telephone-line-section"
          headingText={t('common:connectionTypeTelephoneLineListTitle')}
        >
          <Text style={textStyles.detailText}>{t('oneSendingConnectionTypeTelephoneLineBulletOne')}</Text>
          <Text style={textStyles.detailText}>{t('common:connectionTypeTelephoneLineBulletTwo')}</Text>
          <Text style={textStyles.detailText}>{t('common:connectionTypeTelephoneLineBulletThree')}</Text>
          <Text style={textStyles.detailText}>{t('oneSendingConnectionTypeTelephoneLineBulletFour')}</Text>
        </BulletedListView>
      )
    }
    return returnObj
  }

  getWhatItMeansSection() {
    const { locale, t } = this.props
    if (displayTelephoneLine(locale)) {
      return (
        <BulletedListView
          testID="unable-to-connect-to-lat-list-telephone"
          headingText={t('oneSendingCommunicatorUnableToConnectLatitudeListTitle')}
        >
          <Text style={textStyles.detailText}>{t('oneSendingCommunicatorUnableToConnectLatitudeBulletOne')}</Text>
          <Text style={textStyles.detailText}>{t('oneSendingCommunicatorUnableToConnectLatitudeBulletTwo')}</Text>
          <Text style={textStyles.detailText}>{t('oneSendingCommunicatorUnableToConnectLatitudeBulletThree')}</Text>
        </BulletedListView>
      )
    }
    return (
      <BulletedListView
        testID="unable-to-connect-to-lat-list"
        headingText={t('oneSendingCommunicatorUnableToConnectLatitudeListTitle')}
      >
        <Text style={textStyles.detailText}>{t('oneSendingCommunicatorUnableToConnectLatitudeBulletTwo')}</Text>
        <Text style={textStyles.detailText}>{t('oneSendingCommunicatorUnableToConnectLatitudeBulletThree')}</Text>
      </BulletedListView>
    )
  }

  render() {
    const { t } = this.props
    return (
      <LightStageDetails
        analyticsEvent="OneSendingWave"
        sourceImage={ResourceManager.loadImage('one_sending_wave_header')}
        sourceImageStyle={{ width: 272, height: 59 }}
        accessibilityLabel={t('access:oneSendingWavePageImage')}
      >
        <Text style={styles.lightStageHeader} testID="light-state-details-header">{t('common:yellowSendingOneTitle')}</Text>
        <Text style={styles.lightStageDetailsHeading}>{t('whatItMeans')}</Text>
        {this.getWhatItMeansSection()}
        <Text style={styles.lightStageDetailsHeading}>{t('ifYouSeeThis')}</Text>
        {this.getTelephoneLineSection()}
        <BulletedListView
          headingText={t('common:connectionTypeCellularNetworkListTitle')}
        >
          <Text style={textStyles.detailText}>{t('oneSendingConnectionTypeCellularNetworkBulletOne')}</Text>
          <Text style={textStyles.detailText}>{t('oneSendingConnectionTypeCellularNetworkBulletTwo')}</Text>
          <Text style={textStyles.detailText}>{t('oneSendingConnectionTypeCellularNetworkBulletThree')}</Text>
        </BulletedListView>
        <BulletedListView
          headingText={t('common:connectionTypeInternetListTitle')}
        >
          <Text style={textStyles.detailText}>{t('oneSendingConnectionTypeInternetBulletOne')}</Text>
          <Text style={textStyles.detailText}>{t('oneSendingConnectionTypeInternetBulletTwo')}</Text>
          <Text style={textStyles.detailText}>{t('oneSendingConnectionTypeInternetBulletThree')}</Text>
        </BulletedListView>
        <BulletedListView
          headingText={t('common:verifyTroubleshootingListTitle')}
        >
          <Text style={textStyles.detailText}>{t('common:verifyTroubleshootingBulletTwo')}</Text>
        </BulletedListView>
      </LightStageDetails>
    )
  }
}

OneSendingWavePage.propTypes = {
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return {
    locale: storedData.locale,
  }
}

export const OneSendingWavePageComponent = OneSendingWavePage

export default withTranslation(['indicatorLights', 'common'])(connect(mapStateToProps, null)(OneSendingWavePage))
